module.exports = __webpack_public_path__ + "img/9791186979013.5fd62875.jpg";